import { useEffect, useRef } from 'react';
import { useLazyQuery as useApolloQuery } from '@apollo/client';
import { parseErrors } from 'src/utils/api/error';
import { notification } from 'src/components/Notification';

const useLazyQuery = (query, params, shouldThrow = false, shouldReturnError = false) => {

  const errorToastId = useRef(null);

  useEffect(() => {
    return () => {
      if (errorToastId.current) {
        notification.dismiss(errorToastId.current);
      }
    };
  }, []);

  const [callback, { error, ...rest }] = useApolloQuery(query, {
    fetchPolicy: 'network-only',
    ...params,
  });

  errorToastId.current = null;

  if (error) {
    if (shouldReturnError) {
      return [callback, { ...rest, error, data: null }];
    }
    const message = parseErrors(error).join(', ');
    if (!shouldThrow) {
      errorToastId.current = notification.onQueryFailed(query, message, rest.refetch);

      return [callback, { error, ...rest, data: null }];
    }
    throw new Error(message);
  }

  return [callback, { error, ...rest }];
};

export default useLazyQuery;
